import styled, {
  css,
  FlattenSimpleInterpolation,
} from "styled-components/macro";

import { FlexContainer } from "shared/styles";
import {
  fontSize,
  titlefontStyle,
  colors,
  visuallyHidden,
  breakpoint,
  space,
} from "shared/styles/constants";

export interface StyledTitleProps {
  muted?: boolean;
  size?: "huge" | "xxxl" | "l" | "m" | "s";
  isVisuallyHidden?: boolean;
  fontWeight?: "bold" | "normal";
}

export const StyledTitle = styled.h1<StyledTitleProps>`
  ${titlefontStyle.bold}

  margin-left: ${space.xxs};

  ${({ size }) => {
    switch (size) {
      case "s":
        return fontSize.l;
      case "m":
        return fontSize.xl;
      case "huge":
        return fontSize.huge;
      case "xxxl":
        return fontSize.xxxl;
      default:
        return fontSize.xxl;
    }
  }}

  ${({ muted }) => muted && `color: ${colors.grey5}`};

  ${({ isVisuallyHidden }) => isVisuallyHidden && visuallyHidden};

  ${({ fontWeight }) => fontWeight && `font-weight: ${fontWeight}`};

  line-height: 1;

  svg {
    transform: translateY(1px); // yay font

    ${({ size }) =>
      size === "huge" &&
      css`
        transform: translateY(3px); // yay font
      `}
  }

  @media print {
    color: ${colors.black};
  }
`;

export interface IPrintOptions {
  color?: string;
  fontSize?: FlattenSimpleInterpolation;
  padding?: string;
  margin?: string;
  display?: string;
  fontWeight?: string;
}

export interface StyledTitleInnerProps {
  centerMobile?: boolean;
  printOptions?: IPrintOptions;
}

export const StyledTitleInner = styled(FlexContainer)<StyledTitleInnerProps>`
  ${({ centerMobile }) =>
    centerMobile &&
    css`
      ${breakpoint("m", "down")} {
        justify-content: center;
        text-align: center;
      }
    `}

  @media print {
    font-size: 16px; // Hardcoded since ${fontSize.l} doesn't work here.

    ${({ printOptions }) =>
      printOptions?.color &&
      css`
        color: ${printOptions.color};
      `}

    ${({ printOptions }) => printOptions?.fontSize && printOptions.fontSize}
    ${({ printOptions }) =>
      printOptions?.padding &&
      css`
        padding: ${printOptions.padding};
      `}

      
    ${({ printOptions }) =>
      printOptions?.margin &&
      css`
        margin: ${printOptions.margin};
      `}

      ${({ printOptions }) =>
      printOptions?.display &&
      css`
        display: ${printOptions.display};
      `}
  }
`;
